export const FORMAT_DATE = {
	BASIC_DASH: 'yyyy-MM-dd',
	FRONT: 'dd/MM/yyyy',
	WITH_HOUR: 'dd/MM/yyyy HH:mm:ss',
	YEAR: 'yyyy',
	HOUR: 'HH:mm',
};
